const styles = {
  boxWidth: "xl:max-w-[1280px] w-full",

  heading2:
    "font-poppins font-semibold md:text-[48px] text-xl text-white md:leading-[76.8px] leading-[30px] w-full",
  paragraph:
    "font-poppins font-normal text-dimWhite md:text-[18px] text-[12px] md:leading-[30.8px] leading-[25px]",

  flexCenter: "flex justify-center items-center ",
  flexStart: "flex justify-center items-start",

  paddingX: "sm:px-16 px-6",
  paddingY: "sm:py-16 py-11",
  padding: "sm:px-16 px-6 sm:py-12 py-4",

  marginX: "sm:mx-16 mx-6",
  marginY: "sm:my-16 my-6",
};

export default styles;
